let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cLP9w")).then(() => parcelRequire('jQ7Ma'));